import moment from 'moment';

import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval } from '@utils';

const OVERVIEW_SHORTCUTS = {
  past24Hours: '24 hours',
  past7Days: '7 days',
  past30Days: '30 days',
};

export const getDateShortcuts = () =>
  [
    [OVERVIEW_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
    [OVERVIEW_SHORTCUTS.past7Days, calcShortcutInterval(DATE_SHORTCUTS.past7Days)],
    // TODO: need to open this ff check when timeline data limited to 7 days
    [OVERVIEW_SHORTCUTS.past30Days, calcShortcutInterval(DATE_SHORTCUTS.past30Days)],
  ].filter(Boolean);

// overviewDate - date from which the overview data for the dashboard is available
export const shouldHide = (from, overviewDate, tzOffset, shortcut) => {
  if (!overviewDate) {
    return false;
  }

  const fromDate = moment(from).format();
  const allowedLocalTime = getLocalTime(overviewDate, tzOffset);

  // fromDate < allowedLocalTime
  // checks if the shortcut's from date is before the allowed time
  if (moment(fromDate).isBefore(moment(allowedLocalTime).startOf('day'))) {
    return true;
  }

  return false;
};

export const getLocalTime = (overviewDate, tzOffset) => {
  return moment.utc(overviewDate).utcOffset(tzOffset).format();
};
